export default "__VITE_ASSET__CCc5MnHK__"